import {MarketerRepository} from '../repository/MarketerRepository';

export class DeleteMarketerUseCase {
  constructor (private marketerRepository: MarketerRepository) {}

  async execute (id: number): Promise<boolean> {
    return this.marketerRepository.delete(id);
  }
}
